<template>
  <div class="container-fluid">
    <div class="card-body">
      <b-row align-h="end" class="mb-3">
        <button
          class="btn btn-primary font-weight-bold mr-2"
          style="height: 38px"
          ref="import-orcamento-button"
          v-b-tooltip.top="
            'Somente irá importar orçamento com status: Autorizado'
          "
          @click="buscarOrcamentos"
        >
          Importar Orçamento
        </button>
      </b-row>
      <b-card>
        <b-tabs
          pills
          :horizontal="windowWidth < 768"
          :vertical="windowWidth > 768"
          :nav-wrapper-class="windowWidth > 768 ? 'w-25' : 'w-100'"
          fill
        >
          <Cliente />
          <Produto />
          <Transportador />
          <Faturamento />
          <Informacoes />
        </b-tabs>
      </b-card>
      <div class="card-footer">
        <div class="row">
          <div class="col-lg-12" style="text-align: center">
            <div v-if="canSaveOrcamento">
              <div class="form mb-5">
                <button
                  v-if="store.currentTab !== 0"
                  class="btn btn-secondary font-weight-bold mr-2"
                  @click="handlePrevious"
                >
                  Anterior
                </button>
                <button
                  v-if="store.isUpdate && store.currentTab !== 4"
                  class="btn btn-primary font-weight-bold mr-4"
                  @click="handleNext"
                >
                  Proximo
                </button>
                <button
                  ref="submit_novo_pedido"
                  class="btn btn-primary font-weight-bold"
                  @click="salvarPedido"
                >
                  Salvar
                </button>
                <button
                  ref="submit_previa_nfe"
                  class="btn btn-clean font-weight-bold"
                  @click="confirmCancel('pedidos')"
                >
                  Cancelar
                </button>
              </div>
            </div>
            <div v-else>
              <button
                :disabled="store.currentTab === 0"
                class="btn btn-secondary font-weight-bold mr-4"
                @click="handlePrevious"
              >
                Anterior
              </button>
              <button
                class="btn btn-primary font-weight-bold"
                @click="handleNext"
              >
                Proximo
              </button>
              <button
                ref="submit_previa_nfe"
                class="btn btn-clean font-weight-bold"
                @click="confirmCancel('pedidos')"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="importarOrcamentoPedido"
      title="Importar Orçamento"
      centered
      size="lg"
    >
      <b-form class="form">
        <b-row align-h="center">
          <b-col>
            <b-form-group :key="keyToReRender" label="Orçamento">
              <VueSelect
                ref="orcamento"
                :filterable="false"
                :options="orcamentosToImport"
                v-model="selectedOrcamento"
                @search="onSearchOrcamento"
              >
                <template slot="no-options"> Informe o orçamento</template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.numero }} - {{ option.cliente }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.numero }} - {{ option.cliente }}
                  </div>
                </template>
              </VueSelect>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="primary"
          @click="importarOrcamento"
          ref="importar_orcamento"
        >
          Importar
        </b-button>
        <b-button
          @click="
            () => {
              selectedOrcamento = null;
              cancel();
            }
          "
        >
          Cancelar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import FormatMixin from "../../Application/mixins/FormatMixin";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import { mask } from "vue-the-mask";
import PagamentosMixin from "../../Pdv/mixins/PagamentosMixin";
import InstallmentsMixin from "../../Application/mixins/InstallmentsMixin";
import Cliente from "./componentes/ClienteTab.vue";
import Produto from "./componentes/ProdutoTab.vue";
import Informacoes from "./componentes/Informacoes.vue";
import Transportador from "./componentes/TransportadorTab.vue";
import Faturamento from "./componentes/FaturamentoTab.vue";
import { store } from "../storePedidos";
import VueSelect from "vue-select";
import _ from "lodash";

export default {
  name: "app-pedido-form",
  props: {
    notaCompra: {
      type: Object,
      default: () => {},
    },
  },
  directives: {
    mask,
  },
  data() {
    return {
      store,
      pedidoId: null,
      windowWidth: window.innerWidth,
      orcamentosToImport: [],
      selectedOrcamento: null,
      keyToReRender: 0,
    };
  },
  mixins: [
    validationMixin,
    FormatMixin,
    SistemaMixin,
    ValidacaoMixin,
    PagamentosMixin,
    InstallmentsMixin,
  ],
  components: {
    Cliente,
    Produto,
    Transportador,
    Faturamento,
    Informacoes,
    VueSelect,
  },
  watch: {
    total(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.valorTotal = newValue;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    if (this.$route.params?.pedidoData?.pedidoId) {
      this.id = this.$route.params.pedidoData.pedidoId;
    }
    this.getDataInit();

    this.store.currentTab = 0;

    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {},
    async buscarOrcamentos() {
      const canImport = await this.confirmImportacaoOrcamento();
      if (!canImport) return;

      this.setLoading(true);
      try {
        const response = await this.$http.post(
          "/orcamento/orcamentos-autorizados"
        );
        this.orcamentosToImport = response.data.sort((a, b) => {
          if (a.id_orcamento < b.id_orcamento) return -1;
          if (a.id_orcamento > b.id_orcamento) return 1;
          return 0;
        });
        this.$bvModal.show("importarOrcamentoPedido");
      } catch (error) {
        this.$toast.error("Erro ao buscar orçamentos autorizados");
        console.log(error);
      }
      this.setLoading(false);
    },
    onSearchOrcamento(search, loading) {
      loading(true);
      this.searchOrcamento(loading, search, this);
    },
    searchOrcamento: _.debounce(async (loading, search, vm) => {
      vm.orcamentosToImport = [];
      await vm.$nextTick();
      if (!search) {
        loading(false);
        return;
      }
      try {
        const response = await vm.$http.post(
          "/orcamento/orcamentos-autorizados",
          {
            numero: search,
          }
        );
        vm.orcamentosToImport = _.cloneDeep(response.data);
      } catch (error) {
        vm.$toast.error("Erro ao buscar orçamento");
        console.log(error);
      }
      loading(false);
    }, 500),
    async importarOrcamento() {
      if (!this.selectedOrcamento?.id_orcamento) {
        this.$toast.warning("Selecione um orçamento para importar");
        return;
      }

      this.addLoadingToButton("importar_orcamento");
      try {
        const orcamentos = [
          {
            id_orcamento: this.selectedOrcamento.id_orcamento,
          },
        ];
        const response = await this.$http.post("/pedido/importar-orcamento", {
          orcamentos,
        });

        this.aplicarOrcamentoImportado(response.data, orcamentos);
        this.$toast.success("Orçamento importado com sucesso!");
        this.$bvModal.hide("importarOrcamentoPedido");
        this.selectedOrcamento = null;
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("importar_orcamento");
    },
    aplicarOrcamentoImportado(data, orcamentos) {
      const [formFaturamento, formProduto, formCliente, formTransportador] =
        this.extractDataFromImport(data);

      this.store.orcamentos = orcamentos;
      this.store.formProduto = this.normalizarProdutosImportados(formProduto);
      this.store.formFaturamento = this.normalizarFaturamentoImportado(
        data,
        formFaturamento,
        this.store.formProduto.subtotal
      );
      this.store.formInformacoes = this.normalizarInformacoesImportadas(data);

      const transportador = this.normalizarTransportadorImportado(
        data,
        formTransportador
      );
      if (transportador) this.store.formTransportador = transportador;

      if (formCliente) {
        this.store.formCliente = this.normalizarClienteImportado(
          data,
          formCliente
        );
      }
    },
    normalizarProdutosImportados(formProduto) {
      const produtos = (formProduto?.produtos || []).map((produto, index) => ({
        ...produto,
        currentIndex: index,
      }));

      return {
        produtos,
        subtotal: produtos.reduce(
          (acc, produto) =>
            acc +
            (Number(produto.quantity || 0) * Number(produto.price || 0) -
              Number(produto.discount || 0)),
          0
        ),
      };
    },
    normalizarFaturamentoImportado(data, formFaturamento, subtotal) {
      const desconto = Number(data?.discount || data?.desconto || 0);
      const frete = Number(data?.freightPrice || data?.frete || 0);
      const total = Math.max(subtotal - desconto + frete, 0);
      const pagamentos = this.normalizarPagamentosImportados(
        data,
        formFaturamento,
        total
      );

      return {
        ...(this.store.formFaturamento || {}),
        ...(formFaturamento || {}),
        pagamentos,
        desconto,
        frete,
        informacoes_adicionais: data?.observation || data?.observacao || "",
      };
    },
    normalizarPagamentosImportados(data, formFaturamento, total) {
      const pagamentosOrigem =
        data?.pagamentos || data?.payments || formFaturamento?.pagamentos || [];

      return pagamentosOrigem.map((pagamento, index) => {
        const formaPagamento = pagamento.forma_pagamento || {
          id: pagamento.id || pagamento.paymentMode?.id,
          descricao:
            pagamento.descricao ||
            pagamento.description ||
            pagamento.paymentMode?.description,
          id_meio_pagamento:
            pagamento.id_meio_pagamento || pagamento.paymentMode?.id,
          vezes: pagamento.vezes || 1,
          requer_entrada: pagamento.requer_entrada || false,
          value: 0,
        };
        const valor =
          Number(pagamento.valor || pagamento.value || 0) ||
          (index === 0 ? total : 0);
        const parcelas = pagamento.range || [];
        const range = parcelas.length
          ? parcelas.map((parcela, parcelaIndex) => ({
              ...parcela,
              value:
                Number(parcela.value || 0) ||
                (index === 0 && parcelaIndex === 0 ? valor : 0),
            }))
          : [
              {
                value: valor,
                date: pagamento.vencimento || this.thisDate(),
              },
            ];

        return {
          forma_pagamento: formaPagamento,
          valor,
          vencimento: pagamento.vencimento || range[0]?.date || this.thisDate(),
          range,
        };
      });
    },
    normalizarClienteImportado(data, formCliente) {
      return {
        ...formCliente,
        solicitante: data?.solicitante || formCliente?.solicitante || null,
        vendedor: data?.vendedor?.id_vendedor || data?.vendedor || null,
        vendedorSelecionado: data?.vendedor || null,
      };
    },
    normalizarTransportadorImportado(data, formTransportador) {
      const deliveryInfo =
        formTransportador?.deliveryInfo || data?.deliveryInfo;
      const delivery = deliveryInfo?.delivery;
      const volume = formTransportador?.volume || data?.volume;
      const freightType = formTransportador?.freightType || data?.freightType;

      if (!delivery && !volume && !freightType) return null;

      return {
        ...(delivery || {}),
        nome: delivery?.nome || delivery?.name || null,
        frete: delivery?.frete ||
          freightType || {
            codigo: 9,
            descricao: "Sem Ocorrência de Transporte",
          },
        quantidade: volume?.quantity || null,
        especie: volume?.species || null,
        marca: volume?.brand || null,
        numeracao: volume?.numeration || null,
        pesoBruto: volume?.grossWeight || data?.pesoBruto || null,
        pesoLiquido: volume?.netWeight || data?.pesoLiquido || null,
      };
    },
    normalizarInformacoesImportadas(data) {
      return {
        ...(this.store.formInformacoes || {}),
        observacao: data?.observation || data?.observacao || "",
        pedido_compra: data?.pedido_compra || null,
      };
    },
    async confirmImportacaoOrcamento() {
      if (!this.hasDadosPedidoPreenchidos) return true;

      const result = await this.$swal.fire({
        icon: "warning",
        title: "Importar orçamento?",
        text: "Os dados já preenchidos no pedido serão substituídos pelas informações do orçamento.",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        confirmButtonColor: "#f64e60",
      });

      return result.isConfirmed;
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    handleSair() {
      this.$swal
        .fire({
          icon: "warning",
          title: "Cancelar o lançamento em andamento?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.$router.push({ name: "pedidos" });
          }
        });
    },
    async salvarPedido() {
      this.addLoadingToButton("submit_novo_pedido");
      if (Object.keys(this.$route.params).length !== 0) {
        const { id_pedido } = this.$route.params.pedidoData;

        const data = this.formatDataToSendToOrcamentoApi(
          this.store.formCliente,
          this.store.formProduto,
          this.store.formFaturamento,
          this.store.formInformacoes,
          this.store.formTransportador
        );
        if (this.store.orcamentos.length > 0) {
          data.orcamentos = this.store.orcamentos;
        }
        try {
          await this.$http.post("/pedido/update", {
            id_pedido,
            ...data,
          });
          this.$toast.success("Pedido editado com sucesso!");
          this.$router.push({ name: "pedidos" });
        } catch (error) {
          this.$toast.error("Erro ao editar Pedido!");
        }
      } else {
        try {
          const data = this.formatDataToSendToOrcamentoApi(
            this.store.formCliente,
            this.store.formProduto,
            this.store.formFaturamento,
            this.store.formInformacoes,
            this.store.formTransportador
          );
          if (this.store.orcamentos.length > 0) {
            data.orcamentos = this.store.orcamentos;
          }
          if (this.pedidoId) {
            await this.$http.post("/pedido/update", {
              id_pedido: this.pedidoId,
              ...data,
            });
          } else {
            const { id_orcamento } = await this.$http.post(
              "/pedido/create",
              data
            );
            this.pedidoId = id_orcamento;
          }
          this.$toast.success("Pedido salvo com sucesso!");
          this.$router.push({ name: "pedidos" });
        } catch (error) {
          this.$toast.error("Erro ao salvar Pedido");
          console.log(error);
        }
      }
      this.removeLoadingToButton("submit_novo_pedido");
    },
    handleNext() {
      if (this.store.currentTab === 3) {
        if (this.store.formProduto.subtotal && this.store.formFaturamento) {
          const total = this.store.formFaturamento.pagamentos.reduce(
            (soma, item) => soma + item.valor,
            0
          );
          if (
            total <
            parseFloat(this.store.formProduto.subtotal).toFixed(2) -
              parseFloat(this.store.formFaturamento.desconto).toFixed(2)
          ) {
            this.$toast.warning(
              "Para avançar verifique o valor total dos pagamentos!"
            );
            return;
          }
        }
      }
      if (this.store.currentTab === 6) return;
      this.store.currentTab++;
    },
    handlePrevious() {
      if (this.store.currentTab === 0) return;
      this.store.currentTab--;
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "nutsDigital",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    toolbarDisplay() {
      return true;
    },
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
    displaySubheaderOnDashboard() {
      return this.$route.name !== "dashboard";
    },
    canSaveOrcamento() {
      return this.store.currentTab === 4 || this.store.isUpdate;
    },
    hasDadosPedidoPreenchidos() {
      return (
        !!this.store.formCliente?.id_pessoa ||
        (this.store.formProduto?.produtos || []).length > 0 ||
        (this.store.formFaturamento?.pagamentos || []).length > 0 ||
        !!this.store.formInformacoes?.observacao ||
        !!this.store.formTransportador?.nome
      );
    },
  },
  created() {
    this.store.currentTab = 0;
    this.store.isUpdate = false;
    this.store.orcamentos = this.$route.params?.pedidoData?.orcamentos || [];
    if (Object.keys(this.$route.params).length !== 0) {
      const { id_pedido } = this.$route.params.pedidoData;
      this.pedidoId = id_pedido;
      this.store.isUpdate = true;
    }
  },
};
</script>
